type ColumnDefArray = {
  field: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapFieldsFromEventSpecificData = (eventSpecificData: any): ColumnDefArray[] => {
    let eventData;

    if (Array.isArray(eventSpecificData)) {
        eventData = eventSpecificData[0];
    } else {
        eventData = eventSpecificData;
    }
    
    const columnDefsArray = [];
    for (const key in eventData) {
        if (eventData[key]) {
            columnDefsArray.push({ field: key });
        }
    }
    return columnDefsArray;
};